import { render, staticRenderFns } from "./ArticleExcerpt.vue?vue&type=template&id=f5ae7692&scoped=true&"
import script from "./ArticleExcerpt.vue?vue&type=script&lang=js&"
export * from "./ArticleExcerpt.vue?vue&type=script&lang=js&"
import style0 from "./ArticleExcerpt.vue?vue&type=style&index=0&id=f5ae7692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ae7692",
  null
  
)

export default component.exports